import React from "react";
import { Box, Container, Typography, Paper } from "@mui/material";

function PrivacyPolicy() {
  return (
    <Box className="min-h-screen bg-zinc-900 pt-20">
      <Container maxWidth="lg" className="py-8">
        <Paper elevation={3} className="p-6 bg-neutral-800 text-white">
          <Typography variant="h4" component="h1" className="mb-6 text-center">
            سياسة الخصوصية
          </Typography>

          <Typography variant="body1" className="mb-4">
            آخر تحديث: [03/08/2025]
          </Typography>

          <Typography variant="body1" className="mb-6">
            نشكرك على استخدام تطبيق أوديوهات وموقعنا https://audiohatdar.com. نحن نحترم خصوصيتك ونلتزم بحماية بياناتك الشخصية. توضح هذه السياسة كيفية جمع واستخدام ومشاركة معلوماتك عند استخدامك لخدماتنا.
          </Typography>

          <Typography variant="h5" component="h2" className="mb-4">
            1. المعلومات التي نجمعها
          </Typography>

          <Typography variant="h6" component="h3" className="mb-2">
            أ. المعلومات التي تقدمها لنا:
          </Typography>
          <ul className="list-disc pl-6 mb-4">
            <li>عند إنشاء حساب، قد نطلب منك تقديم معلومات مثل الاسم، البريد الإلكتروني، رقم الهاتف.</li>
            <li>عند الاشتراك في خدماتنا المدفوعة، قد يتم جمع معلومات الدفع عبر مزودي الخدمات الآمنين.</li>
            <li>أي محتوى تقوم بمشاركته داخل التطبيق، مثل التعليقات أو التقييمات.</li>
          </ul>

          <Typography variant="h6" component="h3" className="mb-2">
            ب. المعلومات التي نجمعها تلقائيًا:
          </Typography>
          <ul className="list-disc pl-6 mb-4">
            <li>بيانات الاستخدام، مثل الصفحات التي تزورها داخل التطبيق، وقت الاستخدام، ونوع الجهاز.</li>
            <li>بيانات الجهاز، مثل نظام التشغيل، نوع المتصفح، وعنوان IP.</li>
            <li>ملفات تعريف الارتباط (Cookies) والتقنيات المشابهة لجمع بيانات تحليلية.</li>
          </ul>

          <Typography variant="h5" component="h2" className="mb-4">
            2. كيف نستخدم المعلومات؟
          </Typography>
          <ul className="list-disc pl-6 mb-4">
            <li>تحسين تجربة المستخدم وتقديم خدمات مخصصة.</li>
            <li>معالجة المدفوعات والاشتراكات.</li>
            <li>إرسال إشعارات وتحديثات تتعلق بالخدمات.</li>
            <li>تحليل سلوك المستخدم لتحسين أداء التطبيق.</li>
            <li>الامتثال للمتطلبات القانونية والتنظيمية.</li>
          </ul>

          <Typography variant="h5" component="h2" className="mb-4">
            3. مشاركة المعلومات
          </Typography>
          <Typography variant="body1" className="mb-4">
            لا نبيع أو نشارك بياناتك الشخصية مع أطراف خارجية، باستثناء: مزودي الخدمات الذين يساعدوننا في تشغيل التطبيق مثل بوابات الدفع، إذا طُلب منا ذلك قانونيًا أو لحماية حقوقنا القانونية، في حالة الاندماج أو الاستحواذ على التطبيق من قبل طرف آخر.
          </Typography>

          <Typography variant="h5" component="h2" className="mb-4">
            4. حماية البيانات
          </Typography>
          <Typography variant="body1" className="mb-4">
            نتخذ تدابير أمنية لحماية بياناتك من الوصول غير المصرح به أو التعديل أو الكشف أو التدمير.
          </Typography>

          <Typography variant="h5" component="h2" className="mb-4">
            5. حقوق المستخدم
          </Typography>
          <Typography variant="body1" className="mb-4">
            يحق لك: الوصول إلى بياناتك الشخصية أو تحديثها أو حذفها، إلغاء الاشتراك في الاتصالات التسويقية.
          </Typography>

          <Typography variant="h5" component="h2" className="mb-4">
            6. تخزين البيانات
          </Typography>
          <Typography variant="body1" className="mb-4">
            نحتفظ ببياناتك طالما كان ذلك ضروريًا لتقديم خدماتنا أو وفقًا لما يقتضيه القانون.
          </Typography>

          <Typography variant="h5" component="h2" className="mb-4">
            7. استخدام خدمة المقدمة في الواجهة الأمامية
          </Typography>
          <Typography variant="body1" className="mb-4">
            يستخدم تطبيقنا خدمة المقدمة في الواجهة الأمامية لتشغيل وظائف محددة ضرورية لضمان استمرارية عمل التطبيق بكفاءة، مثل عرض التنبيهات وتنفيذ العمليات في الخلفية. كما يعتمد التطبيق على هذه الخدمة لتشغيل ملفات الصوت في الخلفية، مما يسمح للمستخدم بالاستماع للمحتوى الصوتي أثناء تصفح التطبيق أو عند قفله. نؤكد أن هذه الخدمة لا تقوم بجمع أو تخزين أي بيانات شخصية إضافية عن المستخدمين، بل تُستخدم فقط لتحسين أداء التطبيق وضمان تقديم تجربة مستخدم سلسة.
          </Typography>

          <Typography variant="h5" component="h2" className="mb-4">
            8. جهات الاتصال
          </Typography>
          <Typography variant="body1" className="mb-4">
            يمكنكم الاتصال بنا عند الحاجة من خلال التطبيق من (صفحتي – تواصل معنا) أو الارسال الى بريدنا support@audiohatdar.com
          </Typography>

          <Typography variant="h5" component="h2" className="mb-4">
            9. تحديثات سياسة الخصوصية
          </Typography>
          <Typography variant="body1" className="mb-4">
            قد نقوم بتحديث هذه السياسة من وقت لآخر. سيتم إخطارك بأي تغييرات هامة عبر البريد الإلكتروني أو داخل التطبيق.
          </Typography>

          <Typography variant="body1" className="mt-6">
            باستخدامك للتطبيق، فإنك توافق على هذه السياسة.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}

export default PrivacyPolicy; 